import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { CalendarClock, MapPin, PenLine, Gavel, Users } from "lucide-react";
import { StatusBadge } from "@/components/badges";
import { Skeleton } from "@/components/ui/skeleton";
import { formatDateTime, meetingTypeLabel } from "@/lib/format";

export function MeetingsList({ meetings, companyId }) {
  const navigate = useNavigate();
  return (
    <div className="space-y-3">
      {meetings === null
        ? Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="h-24 rounded-xl" />)
        : meetings.map((m, i) => (
            <motion.button
              key={m.id}
              data-testid={`meeting-row-${m.id}`}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.04 }}
              onClick={() => navigate(`/selskap/${companyId}/moter/${m.id}`)}
              className="group flex w-full items-center gap-4 rounded-xl border border-border/60 bg-card p-5 text-left shadow-sm transition-all hover:-translate-y-0.5 hover:border-primary/30 hover:shadow-md"
            >
              <div className="grid h-11 w-11 shrink-0 place-items-center rounded-lg bg-primary/10 text-primary">
                {m.type === "styremote" ? <Gavel className="h-5 w-5" strokeWidth={1.7} /> : <Users className="h-5 w-5" strokeWidth={1.7} />}
              </div>
              <div className="min-w-0 flex-1">
                <p className="truncate font-headings text-base font-bold tracking-tight group-hover:text-primary">{m.title}</p>
                <p className="mt-0.5 text-xs text-muted-foreground">{meetingTypeLabel(m.type)}</p>
                <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-muted-foreground">
                  <span className="flex items-center gap-1.5"><CalendarClock className="h-3.5 w-3.5" /> {formatDateTime(m.date)}</span>
                  <span className="flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5" /> {m.location}</span>
                  {m.signatures?.length ? <span className="flex items-center gap-1.5"><PenLine className="h-3.5 w-3.5" /> {m.signatures.length} signaturer</span> : null}
                </div>
              </div>
              <StatusBadge status={m.status} />
            </motion.button>
          ))}
      {meetings && meetings.length === 0 ? (
        <div className="rounded-xl border border-dashed border-border p-12 text-center text-sm text-muted-foreground">
          Ingen møter ennå. Opprett det første møtet.
        </div>
      ) : null}
    </div>
  );
}
